import { CalendarEvent } from 'angular-calendar';

import { EventParticipant } from '../../../coaching-observation/observation/observation.model';
import { CommitmentSummaryItem } from '../commitment-summary-item.model';
import {
    EventType,
    ScheduleEvent,
    ScheduleEventStatus,
} from '../models/schedule-event.model';
import { ScheduleItem } from '../models/schedule.model';

import { ScheduleEventFormValue } from './schedule-event.form';

export interface RootState {
    pending: {
        init?: boolean;
        retrieve?: boolean;
        save?: boolean;
    };
    userId?: number;
    startDate?: Date;
    calendarEvents?: Array<CalendarEvent<ScheduleItem>>;
    eventId?: number;
    scheduleEventFormValue: ScheduleEventFormValue;
    eventTypes?: EventType[];
    currentCommitments?: CommitmentSummaryItem[];
    participants?: EventParticipant[];
    savedEvent?: ScheduleEvent;
    updateEvent?: ScheduleEvent;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const defaultFormValue = (): ScheduleEventFormValue => {
    const now = new Date();
    return {
        eventId: null,
        eventTypeId: null,
        date: now,
        participants: [],
        commitments: null,
        startTime: now,
        endTime: new Date(now.getTime() + 30 * 60000),
        eventStatusId: ScheduleEventStatus.ACTIVE,
    };
};

export const defaultState = (): RootState => ({
    pending: {},
    currentCommitments: [],
    userId: null,
    startDate: new Date(),
    eventId: null,
    scheduleEventFormValue: {
        eventId: 0,
        eventTypeId: null,
        participants: [],
        commitments: [],
        date: new Date(),
        eventStatusId: ScheduleEventStatus.ACTIVE,
    },
    eventTypes: [],
    participants: [],
});
